import { Injectable } from '@angular/core';
import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import { IMonitoringService } from './IMonitoringService';
import { Environment } from '../../environments/environment';

@Injectable({ providedIn: 'root' })
export class MonitoringService implements IMonitoringService {
	constructor() {
		const instrumentationKey: string = this.environment.getConfiguration().appInsightsKey;
		this.hasKey = !!instrumentationKey;
		this.isProduction = this.environment.isProduction();
		if (this.hasKey) {
			this.appInsights = new ApplicationInsights({
				config: {
					instrumentationKey,
					enableAutoRouteTracking: true
				}
			});
			this.appInsights.loadAppInsights();
		}
	}
	private readonly environment: Environment = new Environment();
	private readonly appInsights: ApplicationInsights;
	private readonly hasKey: boolean;
	private readonly isProduction: boolean;
	public logException(exception: Error, severityLevel?: number): void {
		if (this.hasKey && this.isProduction) {
			this.appInsights.trackException({ exception, severityLevel });
			return;
		}
		if (this.hasKey) {
			this.appInsights.trackException({ exception, severityLevel });
		}

		console.error(exception);
	}
	public logTrace(message: string, properties?: { [key: string]: any }): void {
		if (this.hasKey && this.isProduction) {
			this.appInsights.trackTrace({ message }, properties);
			return;
		}
		if (this.hasKey) {
			this.appInsights.trackTrace({ message }, properties);
		}
	}
}
